import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionPreactionSystemCase } from '@authority-labs/api-interfaces';
import { PreactionSystemTypeEnum } from '@authority-labs/enums';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-preaction-system-case',
  templateUrl: './check-preaction-system-case.component.html',
  styleUrls: ['./check-preaction-system-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckPreactionSystemCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionPreactionSystemCase;

  types: PreactionSystemTypeEnum[] = [
    PreactionSystemTypeEnum.SingleInterlock,
    PreactionSystemTypeEnum.DoubleInterlock,
    PreactionSystemTypeEnum.NonInterlock
  ];
}
